module.exports = __webpack_public_path__ + "img/bbq-secrets-brand-vertical.8fb25938.jpg";